import styled from 'styled-components';

// Styled component for circled bullets
const CircledBullets = styled.ul`
  list-style-type: disc;

  li {
    margin-left: 1.5em;
  }
`;

export const convertMarkdownToHtml = markdown => {
  let html = markdown;

  // Convert markdown links to HTML links
  html = html.replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2">$1</a>');

  // Convert bullet lists to HTML unordered lists with custom class
  html = html.replace(/(?:^|\n)([-*])\s(.+?)(?=\n|$)/g, '<li>$2</li>');
  html = html.replace(
    /(<li>.*?<\/li>)/g,
    '<CircledBullets>$1</CircledBullets>'
  );

  // Convert newlines to HTML line breaks
  html = html.replace(/\n/g, '<br>');

  return html;
};
